import { SagaIterator } from 'redux-saga';
import { UserFormData } from 'src/modules/common/types/UserFormData';
import { syncProfileForeground } from 'src/modules/profile/sagas/utils/syncProfileForeground';
import { waitProfileSynchronization } from 'src/modules/profile/sagas/utils/waitProfileSynchronization';
import { getProfileSyncState } from 'src/modules/profile/selectors/getProfileSyncState';
import { call, select } from 'typed-redux-saga';

export function* forceProfileSynchronization(
  form: UserFormData,
): SagaIterator<void> {
  // if synchronization is scheduled, new foreground task is triggered
  // to cancel all existing processes and to skip the planned delay
  const profileSyncState = yield* select(getProfileSyncState);
  if (profileSyncState?.state === 'pending') {
    yield* call(syncProfileForeground, form);
  } else {
    yield* call(waitProfileSynchronization);
  }
}
